import React from 'react';

import {
	Loader,
	Alert,
	Button,
	Form,
	FormField,
	FormRow,
	Glyph,
	Input,
	InputGroup,
} from 'kepler';

class Trackdonation extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loader:false,
			propertyInfo:this.props.propertyInfo,
			isResult:this.props.isResult || false,
			trackanother:this.props.trackanother || false,
			istransIdempty:false,
			transactionId:''
		};
		this.formSubmit = this.formSubmit.bind(this);
	}

	componentDidMount() {
		const self = this;
		$('#transactionId').keypress(function (e) {
		  if (e.which == 13) {
		    var transactionId = $("#transactionId").val().trim();
			if(transactionId == "")
			{
				self.setState({
					istransIdempty : true
				});
				return false;
			} else{
				self.setState({
					loader: true,
					istransIdempty : false
				});
				window.location.href = "/givingfund/donationtracker?transactionID="+transactionId+"&trackanother=true";
				return false;
			}

		  }
		});
	}

	formSubmit() {
		const self = this;
		var transactionId = $("#transactionId").val().trim();
		if(transactionId == "")
		{
			self.setState({
				istransIdempty : true
			});
		} else{
			self.setState({
				loader: true,
				istransIdempty : false
			});
			window.location.href = "/givingfund/donationtracker?transactionID="+transactionId+"&trackanother=true";
		}
		
	}
	
	render() {
		let propertyInfo = this.state.propertyInfo;
		let istransIdempty = this.state.istransIdempty;
		let showFormHeadline = (<h1>{propertyInfo.trackdonation.trackanotherdonation}</h1>);
		if (!this.state.isResult && this.state.trackanother){
			showFormHeadline = (<div className="GlyphIcon vx_icon vx_icon-critical-small vx_icon-small GlyphIcon__color--error">{propertyInfo.trackdonation.errorMessage} <a href="contact">{propertyInfo.trackdonation.contactus}</a></div>);
		} else if (!this.state.isResult && !this.state.trackanother){
			showFormHeadline = (<div className="nocontent">&nbsp;</div>);
		}
		return (
			<section className="row-fluid gray">
			<Loader show={this.state.loader} priority={10} type="fixed" size="lg" opacity={0.5}></Loader>
			<div id="trackdonation">
				<Form type="inline">
				{showFormHeadline}
				<InputGroup> 
					<InputGroup.Section>
						<Input type="text" placeholder={propertyInfo.trackdonation.entertransactionid} label={propertyInfo.trackdonation.entertransactionid} id="transactionId" value={this.state.transactionId} onChange={value => this.setState({ transactionId: value })}/>
						<Button type="primary" onClick={this.formSubmit} id="lookupBtn" className="hidden-xs">{propertyInfo.trackdonation.lookup}</Button>
						<span className="icon icon-small icon-search-small visible-xs" aria-hidden="true" onClick={this.formSubmit}></span>
					</InputGroup.Section>
				</InputGroup>
				</Form>
			</div>
			</section>
		);

	}
}
export default Trackdonation;


// WEBPACK FOOTER //
// ./trackdonation/components/trackdonationForm.js